import axios from 'axios'
import type { AddonParamData, OfferAddon } from 'BrokerTsLib/src/dtos'
import type { GenericQueryOptions } from 'BrokerTsLib/src/hooks'
import { useMutation, useQuery } from '@tanstack/react-query'

import { baseUrl } from '.'

const offerAddonApiUrl = import.meta.env.VITE_OFFER_ADDON_API
const url = `${baseUrl}/${offerAddonApiUrl}`

export const useGetAddonOffers = (paramsId: string, options?: GenericQueryOptions<OfferAddon[]>) =>
  useQuery({ queryKey: ['useGetAddonOffers', paramsId], queryFn: () => axios.get<OfferAddon[]>(`${url}/GetAddonOffers?paramsId=${paramsId}`), ...options })

export const useCalculateAddonOffers = () =>
  useMutation({ mutationFn: (data: { hubId: string, offerIds?: number[], forceCalculation?: boolean, paramsId?: string }) =>
    axios.post<OfferAddon[]>(`${url}/CalculateAddonOffers`, data) })

export const useSelectVariant = () =>
  useMutation({ mutationFn: (data: { activeOfferId: number, productId: number }) =>
    axios.post<number>(`${url}/SelectVariant`, data) })

export const useChangeParams = () =>
  useMutation({ mutationFn: (data: { activeOfferId: number, parameterValues: AddonParamData[] }) =>
    axios.post<void>(`${url}/ChangeParams`, data) })

export const useChangePrice = () =>
  useMutation({ mutationFn: (data: { offerId: number, price: number }) =>
    axios.post<OfferAddon>(`${url}/ChangePrice`, data) })

export const useSetAddonSelectedVariant = () =>
  useMutation({ mutationFn: (data: { activeOfferId: number, selected: boolean }) =>
    axios.post<void>(`${url}/SetAddonSelectedVariant`, data) })

export const useSelectOfferAddon = () =>
  useMutation({ mutationFn: (data: { mainOfferId: number, addonOfferId?: number, term?: string }) =>
    axios.post<void>(`${url}/SelectOfferAddon`, data) })

